module.exports = __webpack_public_path__ + "static/media/49850031-U4hs2Sgs.c5a50cd9.JPG";